import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardFooter,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Link,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import { goToBack } from "../common/UtilityHelper";
import { setCurrentTaxonomyL2DataRequest } from "../actions/TaxonomyActions";
import AppHeader from "./AppHeader";
import queryString from "query-string";
import auth from "./Security/Auth";
import { UIServerURL } from "./GlobalSettings";
import ShareContentMessage from "./ShareContentMessage";

class TaxonomyL1 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bIsShared: false,
      TxL1Url: undefined,
    };

    this.onHomeClick = this.onHomeClick.bind(this);
    this.onTaxonomyL1CardClick = this.onTaxonomyL1CardClick.bind(this);
    this._HandleDeppLinkT1 = this._HandleDeppLinkT1.bind(this);
    this.OnLink = this.OnLink.bind(this);
    this._hideShareContentPopUp = this._hideShareContentPopUp.bind(this);
  }

  componentDidMount() {
    document.body.style.overflow = "hidden";
    console.log("Props are ", this.props);
    console.log("Props locations are ", this.props.location);
    if (!this.props.taxonomyL1Data || this.props.taxonomyL1Data.length === 0) {
      this.props.history.push("/home");
    }
    if (this.props.location.search && this.props.location.search.length > 0) {
      if (
        queryString.parse(this.props.location.search).T1Level &&
        queryString.parse(this.props.location.search).T1Level === "G7"
      ) {
        console.log("G7 Captured but internally pointing to Partner Solutions");
        var TaxonomyData = this.props.taxonomyL1Data;
        var G7L1 = TaxonomyData.filter((l1) => {
          return l1.Taxonomy_Name === "Partner solutions";
          //return l1.Taxonomy_Name === "Growth 7 demos";
          //Partner solutions
        });
        console.log("Captured G7 Data is ", G7L1[0]);

        if (G7L1 && G7L1.length > 0) {
          this.onTaxonomyL1CardClick(G7L1[0]);
        }
      }
      if (
        queryString.parse(this.props.location.search).T1Level &&
        queryString.parse(this.props.location.search).T1Level === "AI"
      ) {
        console.log(
          "AI Captured but internally pointing to Artificial Intelligence",
        );
        var TaxonomyData = this.props.taxonomyL1Data;
        var AIL1 = TaxonomyData.filter((l1) => {
          return l1.Taxonomy_Name === "Artificial Intelligence";
          //return l1.Taxonomy_Name === "Growth 7 demos";
          //Partner solutions
        });
        console.log("Captured AI Data is ", AIL1[0]);

        if (AIL1 && AIL1.length > 0) {
          this.onTaxonomyL1CardClick(AIL1[0]);
        }
      }
      if (
        queryString.parse(this.props.location.search).T1Level &&
        queryString.parse(this.props.location.search).T1Level === "HPE_GL"
      ) {
        console.log("Green Lake Captured");
        var TaxonomyData = this.props.taxonomyL1Data;
        var GL1 = TaxonomyData.filter((ll1) => {
          return ll1.Taxonomy_Name === "GreenLake by HPE";
        });
        console.log("Captured GreenLake by HPE Data is ", GL1[0]);

        if (GL1 && GL1.length > 0) {
          this.onTaxonomyL1CardClick(GL1[0]);
        }
      }
      if (
        queryString.parse(this.props.location.search).T1Level &&
        queryString.parse(this.props.location.search).T1Level === "CUST_ACC"
      ) {
        console.log("Customer Acceleration Plays Captured");
        var TaxonomyData = this.props.taxonomyL1Data;
        var CA1 = TaxonomyData.filter((cal1) => {
          return cal1.Taxonomy_Name === "Customer Acceleration Plays";
        });
        console.log("Customer Acceleration Plays Data is ", CA1[0]);

        if (CA1 && CA1.length > 0) {
          this.onTaxonomyL1CardClick(CA1[0]);
        }
      }

      if (
        queryString.parse(this.props.location.search).T1Level &&
        queryString.parse(this.props.location.search).T1Level === "TBR" &&
        auth.getT1CategoryParam()
      ) {
        console.log("Captured T1 Param is", auth.getT1CategoryParam());
        var T1Param = auth.getT1CategoryParam();
        var TaxonomyData = this.props.taxonomyL1Data;
        var GL1 = TaxonomyData.filter((ll1) => {
          return ll1.Taxonomy_Name === T1Param;
        });
        console.log("Captured or Matched DeepLinked TaxoL1 is ", GL1[0]);

        if (GL1 && GL1.length > 0) {
          auth.removeT1CategoryParam();
          this.onTaxonomyL1CardClick(GL1[0]);
        }
      }

      /*       if (
        queryString.parse(this.props.location.search).T1Level &&
        auth.getT1CategoryParam()
      ) {
        console.log("Deep Link Captured is ", auth.getT1CategoryParam());
        var TaxonomyData = this.props.taxonomyL1Data;
        var deepT1 = auth.getT1CategoryParam();
        var GL1 = TaxonomyData.filter((ll1) => {
          return ll1.Taxonomy_Name === deepT1;
        });
        console.log("Captured or Matched T1 Data is ", GL1[0]);

        if (GL1 && GL1.length > 0) {
          this.onTaxonomyL1CardClick(GL1[0]);
        }
      } */
      // Here to handle deeplinked scenario
      /*       if (this.props.taxonomyL1Data && auth.getT1CategoryParam()) {
        console.log(
          "T1 Category comes from deeplink is ",
          auth.getT1CategoryParam()
        );
        this._HandleDeppLinkT1();
      } */
    }
  }

  _HandleDeppLinkT1() {
    var TaxonomyData = this.props.taxonomyL1Data;
    var deepT1 = auth.getT1CategoryParam();
    var L1Dt = null;
    for (var i = 0; i < TaxonomyData.length; i++) {
      if (TaxonomyData[i].Taxonomy_Name == deepT1) {
        L1Dt = TaxonomyData[i];
        break;
      }
    }
    /*  var L1Dt = TaxonomyData.filter((ll1) => {
      return ll1.Taxonomy_Name === auth.getT1CategoryParam();
    }); */
    console.log("Matched L1 Category Data  as per Deep Link T1 is ", L1Dt);

    if (L1Dt && L1Dt.TaxonomyItems && L1Dt.TaxonomyItems.length > 0) {
      auth.removeT1CategoryParam();
      this.onTaxonomyL1CardClick(L1Dt[0]);
    } else {
      this.props.history.push("/home");
    }
  }

  OnLink(selectedTaxL1Name) {
    console.log(
      "Link btn clicked to create for Tax Level 1 deeplink URL - " +
        selectedTaxL1Name,
    );
    var lnk = UIServerURL + "?t1=" + encodeURIComponent(selectedTaxL1Name);
    this.setState({ TxL1Url: lnk, bIsShared: true });
  }

  _hideShareContentPopUp() {
    this.setState({ TxL1Url: undefined, bIsShared: false });
  }

  _HPEOnBackClick() {
    goToBack(this.props.history);
  }

  onHomeClick = () => {
    this.props.history.push("/home");
  };

  onTaxonomyL1CardClick = (selectedCardData) => {
    console.log("Selected Card Data is ", selectedCardData);
    this.props.setCurrentTaxonomyL2Data(selectedCardData);
    if (selectedCardData && selectedCardData.Taxonomy_Name) {
      this.props.history.push(`/hpd/${selectedCardData.Taxonomy_Name}`);
    }
  };
  render() {
    const { history, taxonomyL1Data } = this.props;
    console.log("TaxonomyL1Data is ", taxonomyL1Data);
    console.log("Deep Link URL for clicked Tax L1 is ", this.state.TxL1Url);
    var TxLnkUrl = this.state.bIsShared ? this.state.TxL1Url : null;
    var isTxDeepLink = this.state.bIsShared;

    return (
      <Box fill="vertical" align="stretch" justify="start">
        <Main
          overflow="auto"
          background={{ image: "url('')" }}
          flex
          align="stretch"
          justify="start"
          margin={{ bottom: "xlarge" }}
        >
          <AppHeader />
          <Box
            align="stretch"
            justify="center"
            flex="grow"
            background={{ color: "background-back" }}
            direction="row"
          >
            <Box
              align="stretch"
              justify="start"
              flex="shrink"
              pad={{ horizontal: "large", vertical: "medium" }}
              gap="medium"
              basis="xlarge"
            >
              <Header
                align="start"
                direction="column"
                flex={false}
                justify="start"
                gap="xxsmall"
              >
                <Button
                  label="Home"
                  icon={<FormPrevious />}
                  gap="xsmall"
                  onClick={this.onHomeClick}
                  //onClick={() => goToBack(history)}
                />
                <Heading margin="none">All demos</Heading>
              </Header>
              <Header
                align="center"
                direction="row"
                flex={false}
                justify="start"
                gap="medium"
              >
                {/*                 <Box
                  align="center"
                  justify="center"
                  direction="row"
                  gap="small"
                  onClick={[{ screen: 1485, label: "ListView", key: 1485 }]}
                >
                  <TextInput
                    icon={<Search />}
                    placeholder="Search content"
                    suggestions={["HPE SimpliVity", "Primera"]}
                  />
                </Box> */}
              </Header>
              <Box align="stretch" justify="center">
                {isTxDeepLink && TxLnkUrl && (
                  <ShareContentMessage
                    url={TxLnkUrl}
                    hide={this._hideShareContentPopUp}
                  />
                )}
                <Grid columns={{ size: "flex", count: 4 }} gap="small">
                  {taxonomyL1Data.length &&
                    taxonomyL1Data.map((dataObj) => {
                      return (
                        <Card
                          key={dataObj.TaxonomyId}
                          justify="start"
                          gap="small"
                          //onClick={() => this.onTaxonomyL1CardClick(dataObj)}
                          hoverIndicator
                        >
                          <Box
                            align="start"
                            justify="start"
                            fill="horizontal"
                            //border={{ color: "brand", size: "medium" }}
                            // round="full"
                            background={{ color: "brand" }}
                            elevation="medium"
                            //animation={{ type: "jiggle", duration: 3000 }}
                            onClick={() => this.onTaxonomyL1CardClick(dataObj)}
                          >
                            <CardHeader
                              align="center"
                              direction="row"
                              flex={false}
                              justify="between"
                              gap="medium"
                              style={{ padding: "16px 12px" }}
                            >
                              <Heading margin="none" level="2" size="xsmall">
                                {dataObj.Taxonomy_Name}
                              </Heading>
                            </CardHeader>
                          </Box>
                          <CardBody pad="small">
                            {dataObj.TaxonomyItems.map((taxonomyBody) => {
                              return (
                                <Box
                                  align="start"
                                  justify="start"
                                  fill="horizontal"
                                  //border={{ color: "brand", size: "medium" }}
                                  // round="full"
                                  //background={{ color: "brand" }}
                                  // elevation="small"
                                  // animation={{ type: "jiggle", duration: 3000 }}
                                  onClick={() =>
                                    this.onTaxonomyL1CardClick(dataObj)
                                  }
                                >
                                  <Text color="text-strong">
                                    {taxonomyBody.Taxonomy_Name}
                                  </Text>
                                </Box>
                              );
                            })}
                          </CardBody>

                          <CardFooter pad="small">
                            <Box
                              align="start"
                              justify="start"
                              fill="horizontal"
                            >
                              <Button
                                icon={<Link color="brand" />}
                                hoverIndicator
                                tip={{
                                  dropProps: { align: { left: "right" } },
                                  content: "Copy Url to Clipboard",
                                }}
                                onClick={() =>
                                  this.OnLink(dataObj.Taxonomy_Name)
                                }
                              />
                            </Box>
                            <Box align="end" justify="end" fill="horizontal">
                              <Box
                                align="center"
                                justify="center"
                                border={{ color: "brand", size: "medium" }}
                                round="full"
                                background={{ color: "brand" }}
                                elevation="small"
                                animation="pulse"
                                style={{ padding: "5px" }}
                                width="40px"
                                height="40px"
                              >
                                <Text color="white">
                                  {dataObj.Content_Count &&
                                  dataObj.Content_Count > 0
                                    ? dataObj.Content_Count
                                    : 0}
                                </Text>
                              </Box>
                            </Box>
                            {/*                        <Box
                              align="start"
                              justify="start"
                              fill="horizontal"
                            > */}
                            {/* </Box> */}
                          </CardFooter>
                        </Card>
                      );
                    })}
                </Grid>
              </Box>
            </Box>
          </Box>
        </Main>
      </Box>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    taxonomyL1Data: state.taxonomy.taxonomyData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentTaxonomyL2Data: (data) => {
      dispatch(setCurrentTaxonomyL2DataRequest(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaxonomyL1);
